<template>
	<component :is="optionComponent" />
</template>
<script>
	import { defineAsyncComponent } from "vue";
	export default {
		name: "Dashboard",
		inject: ["store"],

		computed: {
			optionComponent() {
				return defineAsyncComponent(() => {
					const dashboards = [
						"admin",
						"general_manager",
						"sales_manager",
						"area_sales_manager",
						"team_leader",
						"sales_executive",
						"service_executive",
					];
					let test = dashboards.includes(this.store.state.user.activeRole);
					if (test)
						return import(
							`@/views/${this.store.state.user.activeRole}/Dashboard.vue`
						);
					return import(`@/views/sales_executive/Dashboard.vue`);
				});
			},
		},
	};
</script>
